import script from "./MapBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"
export * from "./MapBlindenzorglichtliefde.vue?vue&type=script&setup=true&lang=js"

import "./MapBlindenzorglichtliefde.vue?vue&type=style&index=0&id=1edab386&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1edab386"]])

export default __exports__